import { render, staticRenderFns } from "./digiPayTranscation.vue?vue&type=template&id=3225c3fd&scoped=true&"
import script from "./digiPayTranscation.vue?vue&type=script&lang=js&"
export * from "./digiPayTranscation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3225c3fd",
  null
  
)

export default component.exports